import { getSSOConfiguration, getEnvironment, resetPassword, loginUser, shibLoginUser, verifyUser,
  extendUserSession, signUpUser, updateEmailCampaignClicks, getInstitutionMeta, getPreCuratedInstitutions,
  postWidgetAdminSignUp, putSignUpWidgetAdmin, postWidgetAdminSignUpNotOnList, learnerSelfRegistration,
  verifySelfRegistration} from '../api'

export const loadSSOConfiguration = ({ state, commit }) => {
  return getSSOConfiguration()
}

export const loadEnvironment = ({ state, commit }) => {
  return getEnvironment()
}

export const loadResetPassword = ({ state, commit }, email) => {
  return resetPassword(email)
}

export const loadLoginUser = ({ state, commit }, data) => {
  return loginUser(data)
}

export const loadVerifyUser = ({ state, commit }, data) => {
  return verifyUser(data)
}

export const loadSignupUser = ({ state, commit }, {campaignId, institutionOpenId, data}) => {
  return signUpUser(campaignId, institutionOpenId, data)
}

export const loadWidgetAdminSignUp = ({ state, commit }, {institutionOpenId, data}) => {
  return postWidgetAdminSignUp(institutionOpenId, data)
}

export const loadWidgetAdminSignUpNotOnList = ({ state, commit }, data) => {
  return postWidgetAdminSignUpNotOnList(data)
}

export const loadPreCuratedInstitutions = ({ state, commit }) => {
  return getPreCuratedInstitutions()
}

export const loadUpdateEmailCampaignClicks = ({ state, commit }, {campaignId, institutionOpenId}) => {
  return updateEmailCampaignClicks(campaignId, institutionOpenId)
}

export const loadInstitutionMeta = ({ state, commit }, institutionOpenId) => {
  return getInstitutionMeta(institutionOpenId)
}

export const loadShibLogin = ({ state, commit }, token) => {
  return shibLoginUser(token)
}

export const setUserInfo = ({ state, commit }, userObj) => {
  setAccessToken(userObj.password)
  commit('LOAD_USER_OBJECT', userObj)
  let loginTime = (new Date()).getTime()
  setStorageItem('loginTime', loginTime)
  let fullName = userObj.firstName + ' ' + userObj.lastName
  setStorageItem('userFullName', fullName)
  commit('LOAD_USER_NAME', fullName)
  setStorageItem('userid', userObj.uuid)
  let role = userObj.roles[0].role
  setStorageItem('userrole', role)
  setStorageItem('institutionId', userObj.institutionId)
  commit('LOAD_USER_ROLE', role)
  setStorageItem('user_personal_LS_UUID', userObj.personalLearningSpaceUUID)
  let permission = userObj.permission
  commit('LOAD_PERMISSION', permission)
  setStorageItem('version', permission.version)
  setStorageItem('userobj', JSON.stringify(userObj))
  commit('LOAD_USER_PREFERENCES', userObj.userPreferences)
  let major1 = userObj.major1
  if (major1) {
    setStorageItem('major1', major1)
  }
  let minor1 = userObj.minor1
  if (minor1) {
    setStorageItem('minor1', minor1)
  }
  let concentration1 = userObj.concentration1
  if (concentration1) {
    setStorageItem('concentration1', concentration1)
  }
}
export const setInpersonateUserInfo = ({ state, commit }, userObj) => {
  setStorageItem('inpersonatingUser', userObj.inpersonatingUser)
  setStorageItem('inpersonatingUserName', userObj.inpersonatingUserName)
}
export const getInpersonateUser = () => {
  return getStorageItem('inpersonatingUser')
}

export const setTemporaryUser = ({ state, commit }) => {
  setStorageItem('tempUser', true)
  commit('LOAD_TEMP_USER_FLAG', true)
}

export const setTemporaryUserToFalse = ({ state, commit }) => {
  setStorageItem('tempUser', false)
  commit('LOAD_TEMP_USER_FLAG', false)
}

export const setAccessToken = (token) => {
  setStorageItem('token', token)
  setStorageItem('baseUrl', window.location.origin)
}

export const setStorageItem = (key, value) => {
  localStorage.setItem(key, value)
}

export const loadExtendSession = ({ state, commit }, token) => {
  return extendUserSession(token).then(res => {
    let loginTime = (new Date()).getTime()
    localStorage.setItem('loginTime', loginTime)
    return res
  })
}

export const loadLearnerSelfRegistration = ({ state, commit }, { orgId, user }) => {
  return learnerSelfRegistration(orgId, user)
}

export const loadVerifySelfRegistration = ({ state, commit }, data) => {
  return verifySelfRegistration(data)
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/actions.js